<template>
    <RealtimeSystem
        :componentKey="componentKey"
        :onAnyEventsSocketScheme="onAnyEventsSocketScheme"
        @exportSet="exportSet"
    />
</template>

<script>
import RealtimeSystem from './RealtimeSystem.vue';
import { mapMutations } from 'vuex';
export default {
    name: 'RealtimeSystemMap',
    components: {RealtimeSystem},
    data: () => ({
        componentKey: 'RealtimeSystemMap',
        onAnyEventsSocketScheme: [
			{
				id: 'exportSet',
				eventNameSocket: 'export_set_queue_job',
				emitNameComponent: 'exportSet',
			},
            {
                id: 'exportTransaction',
                eventNameSocket: 'export_transaction_queue_job',
                emitNameComponent: 'exportSet',
            },
		]
    }),
    methods: {
        ...mapMutations('history', [
            'addHistoryItem',
        ]),
        exportSet(data) {
            const {success = false, history = "", error = ""} = data;
            const {url = null} = history;
            this.addHistoryItem(history);
            console.log(data)
            if(success && url !== null){
                this.$notify.addNotification({
                    type: 'success',
                    title: 'Задача на экспорт успешно выполнена',
                    description: `<a href="${url}" target="_blank" style="color: #4A92F6">${history?.title}</a>`,
                    duration: Infinity,
                    position: 'bottom-right'
                });

            }
            if(!success){
                this.$notify.addNotification({
                    type: 'error',
                    title: 'Не удалось выполнить экспорт',
                    description: error,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            }
        }
    }
}
</script>
